<template>
    <div class="main">
        <MyHeader index="1"></MyHeader>
        <div class="title">
            <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>关于我们</h2>
                <h3>About Us</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>About Us</h2>
                <h3>关于我们</h3>
            </div>
        </div>
        <div class="aboutUsInfo">
            <div class="container">
            
             <nav aria-label="Breadcrumb" class="breadcrumb2">
			  <ul>
				<li><a href="/">{{ $t("header.home") }}</a> </li>
				<li><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></li>
				<li><span aria-current="page">{{ $t("header.aboutUs") }}</span></li>
			  </ul>
			</nav>
			
                <div class="content">
                    <div class="leftMenu">
                        <ul>
                            <li>
                                <router-link to="/aboutUs">
                                    <i>{{$t('ccapp.tit')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/frame">
                                    <i>{{$t('ccapp.tit1')}}</i>
                                    <b></b>
                                </router-link>
                                <ul class="second" style="margin-top: 10px">
                                    <li >
                                        <router-link :to="{name:'figure',params:{id:1}}">
                                            <i>{{$t('ccapp.tit2')}}</i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:2}}">
                                            <i>{{$t('ccapp.tit3')}}</i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:3}}">
                                            <i>{{$t('ccapp.tit4')}}</i>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="on">
                                <router-link to="/job">
                                    <i>{{$t('ccapp.tit5')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                    	<h2 v-if="fullList.length > 0 && this.$i18n.locale == 'zh_CN'">- 全职招聘 -</h2>
                    	<h2 v-if="fullList.length > 0 && this.$i18n.locale == 'en_US'">- Full-time Positions -</h2>
                        <ul class="experience">
                            <li v-for="item in fullList">
                                <router-link :to="{name:'experience',params: {id: item.id}}">
                                    <h4>岗位：{{item.title}}</h4>
                                    <!--<h6>时间：{{item.created_at}}</h6>-->
                                    <h6>地点：{{item.address}}</h6>
                                </router-link>
                            </li>
                            <!-- <li>
                                <router-link :to="{name:'experience',params: {id: 1}}">
                                    <h4>{{$t('name.project')}}</h4>
                                    <h6>2020-08-20</h6>
                                    <h6>{{$t('label.job')}}</h6>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'experience',params: {id: 2}}">
                                    <h4>{{$t('name.media')}}</h4>
                                    <h6>2020-08-20</h6>
                                    <h6>{{$t('label.job')}}</h6>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'experience',params: {id: 4}}">
                                    <h4>{{$t('name.media2')}}</h4>
                                    <h6>2020-12-22</h6>
                                    <h6>{{$t('label.job')}}</h6>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{name:'experience',params: {id: 5}}">
                                    <h4>{{$t('name.project2')}}</h4>
                                    <h6>2022-12-22</h6>
                                    <h6>{{$t('label.job')}}</h6>
                                </router-link>
                            </li> -->
                            
                        </ul>
                        <h2 style="margin-top:35px;" v-if="practiceList.length > 0 && this.$i18n.locale == 'zh_CN'">- 实习机会 -</h2>
                        <h2 style="margin-top:35px;" v-if="practiceList.length > 0 && this.$i18n.locale == 'en_US'">- Internships -</h2>
                         <ul class="experience">
                           <li v-for="item in practiceList">
                                <router-link :to="{name:'experience',params: {id: item.id}}">
                                    <h4>岗位：{{item.title}}</h4>
                                    <!-- <h6>时间：{{item.created_at}}</h6>-->
                                    <h6>地点：{{item.address}}</h6>
                                </router-link>
                            </li>
                            <!-- <li>
                                <router-link :to="{name:'experience',params: {id: 3}}">
                                    <h4>{{$t('name.interns')}}</h4>
                                    <h6>2020-08-20</h6>
                                    <h6>{{$t('label.job')}}</h6>
                                </router-link>
                            </li> -->
                        </ul>
                         <!--
                         <h1>志愿者社群</h1>
                         <ul class="experience">
                            
                        </ul>
                        -->
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader';
    import MyFooter from './common/MyFooter';
    import filter from '../filter.js';
    import {createJobs, getJobsList, getJobsDetails, deleteJobs, putJobs} from '@/services/jobs';
    export default {
        name: "JobAndStudy",
        components: { MyHeader,MyFooter },
        data(){
            return{
                full:{
                    page_size:100,
                    page:1,
                    search_str:'',
                    category_id:72,
                    language:'',
                    type: 1
                },
                practice:{
                    page_size:100,
                    page:1,
                    search_str:'',
                    category_id:72,
                    language:'',
                    type: 0
                },
                fullList:[],
                practiceList:[],
                pageInfo:{
                    total:0,        // 记录总条数   默认空，如果小于pageNum则组件不显示   类型Number
                    current:1,      // 当前页数，   默认为1                             类型Number
                    pagenum:6,      // 每页显示条数,默认10                              类型Number
                    pagegroup:3,    // 分页条数     默认为5，需传入奇数                  类型Number
                    skin:'#13AE67'  // 选中页码的颜色主题 默认为'#16a086'                类型String
                },
            }
        },
        mounted(){
            this.getList(this.full);
            this.getList(this.practice);
        },
        methods:{
            getList(params){
                
                getJobsList(params).then(res => {
                    let list = res.items;
                    for (var i in list) {
                        let item = list[i];
                        item.created_at = filter.dateFormat(item.created_at,'yyyy-mm-dd');
                        item.updated_at = filter.dateFormat(item.updated_at,'yyyy-mm-dd');
                    }
                    
                    // this.pageInfo.total= res._meta.totalCount;
                    // this.pageInfo.current= res._meta.currentPage;
                    // this.pageInfo.pagenum= res._meta.perPage;
                    if(params.type == 0){
                        this.fullList = list
                    }
                    if(params.type == 1){
                        this.practiceList = list
                    }
                    
                }).catch();
            },
            pagechange(current){
                this.page.page = current;
                this.getList();
            },
            search(){
                this.getList();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .main{
        .title{
            height:380px;
            background: url("./image/aboutUsImg.jpg") no-repeat center center;
            background-size: cover;
            .container{
                h2{
                    padding-top: 180px;
                    text-align: center;
                    color: #304656;
                    height:42px;
                    font-size:32px;
                    font-weight:bold;
                    line-height:42px;
                }
                h3{
                    text-align: center;
                    height:29px;
                    font-size:22px;
                    line-height:29px;
                    color: #304656;
                }
               
            }
        }
        .aboutUsInfo{
            .container{
                border-top: 1px solid #E6E6E6;
                .content{
                    margin-top: 30px;
                    overflow: hidden;
                    margin-bottom: 48px;
                    .leftMenu{
                        width: 246px;
                        float: left;
                        ul{
                            li{
                                line-height: 36px;
                                margin-bottom: 10px;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                &:nth-of-type(2){

                                }
                                a{
                                    padding: 0 16px;
                                    border-radius: 18px;
                                    display: block;
                                    height: 100%;
                                    overflow: hidden;
                                }
                                i{
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }
                                b{
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 36px;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }
                            .on{

                                a{
                                    background: #13AE67;
                                }
                                i{
                                    color: #FFFFFF;
                                }
                                b{
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                    transform:rotate(90deg);
                                }
                            }
                            .second{
                                li{
                                    a{
                                        text-indent: 20px;
                                        background: transparent;
                                        i{
                                            color: #252525;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .rightContent{
                        float: right;
                        margin-left: 88px;
                        width: 866px;
                        h2{
							height:36px;
							font-size:20px;
							font-weight:bold;
							color:rgba(37,37,37,1);
							line-height:26px;
							margin-bottom:15px;
						}
                        .experience{
                            li{
                                padding-bottom: 30px;
                                border-bottom: 1px solid #EEEEEE;
                                margin-bottom: 30px;
                                &:last-child{
                                    margin-bottom: 0;
                                     border-bottom: 0px solid #EEEEEE;
                                }
                                a{
                                    display: block;
                                }
                               
                                h3{
                                    height:26px;
                                    font-size:20px;
                                    font-weight:bold;
                                    color:rgba(37,37,37,1);
                                    line-height:26px;
                                }
                                 h4{
                                    height:26px;
                                    font-size:18px;
                                    font-weight:bold;
                                    color:rgba(37,37,37,1);
                                    line-height:26px;
                                }
                                h6{
                                    margin-top: 12px;
                                    height:16px;
                                    font-size:12px;
                                    color:rgba(102,102,102,1);
                                    line-height:16px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>
